import { call, put, takeEvery } from 'redux-saga/effects';
import { golfApi } from 'config/axios';
import { toQueryString } from 'utils/UrlUtil';

import { FETCH_GOLF_COURSES, FETCH_GOLF_COURSES_SUCCESS, FETCH_GOLF_COURSES_FAIL } from 'actions/golfCourseActions.js';

export function* fetchGolfCoursesSaga(action) {
    try {
        const queryString = toQueryString({
            'per-page': 10000,
            'user-locale': action.userLocale
        });

        const url = `/gcs-golfcommunity/api/v2/course-snapshot/player${queryString}`;

        const response = yield call(golfApi.get, url);

        yield put({
            type: FETCH_GOLF_COURSES_SUCCESS,
            golfCourses: response.data.courseSnapshots || []
        });
    } catch (e) {
        yield put({
            type: FETCH_GOLF_COURSES_FAIL,
            golfCourses: []
        });
    }
}

export const golfCourses = [takeEvery(FETCH_GOLF_COURSES, fetchGolfCoursesSaga)];
